import dynamic from 'next/dynamic';

const RichTextWrapper = dynamic(() => import('./RichText'));

export default RichTextWrapper;